<!-- clinicajure-staff-app/src/App.vue -->
<template>
  <div id="app">
    <header class="app-header">
      <img src="@/assets/logo.png" alt="Logo de la Clínica Jure" class="app-logo" v-if="hasLogo" />
      <h1 :style="{ color: headerTitleColor }">Panel de Gestión para Personal</h1>
      <button v-if="user" @click="logout" class="logout-button">Cerrar Sesión</button>
    </header>

    <div class="content">
      <StaffLoginComponent v-if="!user" @login-success="handleLoginSuccess" />
      <StaffDashboard v-else :staffUser="user" /> <!-- Aquí usamos el nuevo componente -->
    </div>
  </div>
</template>

<script>
import StaffLoginComponent from './components/StaffLogin.vue';
import StaffDashboard from './components/StaffDashboard.vue'; // <-- Importamos el StaffDashboard
// Importamos las herramientas de Firebase
import { auth } from '@/firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';

export default {
  name: 'App',
  components: {
    StaffLoginComponent,
    StaffDashboard, // <-- Lo registramos
  },
  data() {
    return {
      user: null, // Guardará el objeto de usuario de Firebase si está logeado
      hasLogo: true, // Control para el logo
      headerTitleColor: '#00bcd4', // Color turquesa para el título principal
    };
  },
  created() {
    // Observador del estado de autenticación de Firebase
    onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        this.user = firebaseUser; // Usuario logeado
        console.log('Personal autenticado:', firebaseUser.email);
      } else {
        this.user = null; // No hay usuario
        console.log('No hay personal autenticado.');
      }
    });
  },
  methods: {
    handleLoginSuccess(loggedInUser) {
      this.user = loggedInUser;
    },
    async logout() {
      try {
        await signOut(auth);
        alert('Has cerrado sesión correctamente.');
      } catch (error) {
        console.error('Error al cerrar sesión:', error);
        alert('Hubo un error al cerrar sesión.');
      }
    }
  }
};
</script>

<style>
/* ... (Estilos anteriores sin cambios para App.vue de la app del personal) ... */
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f0f2f5; /* Un gris claro diferente */
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333; /* Gris más oscuro */
  margin-top: 60px;
}

.app-header {
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.app-logo {
  max-height: 80px;
  margin-bottom: 10px;
}

h1 {
  margin-top: 0;
}

.logout-button {
  background-color: #dc3545; /* Rojo para cerrar sesión */
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 0.9em;
}

.logout-button:hover {
  background-color: #c82333;
}

.content {
  padding: 0 20px;
}
</style>
